import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subscription } from '../subscription.models';
import { QueryParams } from '../../models/http.models';
import { selectAccountId } from '../../account/store/account.selectors';
import { AppState } from '../../store';
import { environment } from '../../../environments/environment';
import { ListParams } from '../../common/helper/query-params-generic-list.helper';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsResource {
  private apiRoot: string = `${environment.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(params?: ListParams): Observable<Subscription> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Subscription>(`${this.apiRoot}/${account_id}/api/subscription`, {
          params: params as QueryParams,
        }),
      ),
    );
  }
}
